import * as React from 'react';

interface UsageTableProps {
  rows: Record<any, any>[];
}
export const UsageTable = ({ rows }: UsageTableProps) => (
  <table>
    <thead>
      <tr>
        <td>Type</td>
        <td>Average Rate</td>
        <td># of Segments</td>
        <td>Balance</td>
      </tr>
    </thead>
    <tbody>{rows}</tbody>
  </table>
);
